import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 9"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.793 7.793a1 1 0 0 0 1.414 0l6.086-6.086c.63-.63.184-1.707-.707-1.707H1.414C.524 0 .077 1.077.707 1.707l6.086 6.086Z",
  fill: "#101010"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }